<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container"  trigger="click">
        <div class="avatar-wrapper">
          <img src="../../../static/images/avator.jpg" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
          <div class="name">
            <p :class="{two:userInfo.workNo}" v-if="userInfo.loginName">
              <b>{{userInfo.organization ? (userInfo.organization.orgName || '') : ''}}({{userInfo.loginName}})</b>
            </p>
            <p class="two" v-if="userInfo.workNo">{{userInfo.workNo}}</p>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">
              <svg-icon icon-class="exit"></svg-icon>退出
            </span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="editPassword">
            <span style="display:block;">
              <svg-icon icon-class="exit"></svg-icon>修改密码
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="select" v-if="userInfo.isPlatformManager == '1'">
      <el-select v-model="role" placeholder="请选择" size="small" @change="handleChange" clearable>
        <el-option
          v-for="item in options"
          :key="item.orgId"
          :label="item.orgName"
          :value="item.orgId"
        ></el-option>
      </el-select>
    </div>
    <reset-password v-if="visible" :visible.sync="visible"></reset-password>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import resetPassword from '@/components/login/resetPassword'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    resetPassword
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data () {
    return {
      visible: false,
      userInfo: window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : null,
      options: [],
      role: ''
    }
  },
  methods: {
    editPassword () {
      this.visible = true;
    },
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout () {
      // await this.$store.dispatch('user/logout')
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userInfo');
      window.localStorage.removeItem('router');
      window.localStorage.removeItem('isPlatformManager');
      window.localStorage.removeItem('orgType');
      window.localStorage.removeItem('Auths');
      window.localStorage.removeItem('menuCode');
      window.localStorage.removeItem('orgIdAdministrator');
      Vue.prototype.$getRouter = null;
      this.$router.push({ path: '/login' })
      window.location.reload()
    },
    getOptions () {
      this.$axios.get('/user/selByAdministrator').then(res => {
        this.options = res.data.data;
      })
    },
    handleChange (v) {
      window.localStorage.setItem('orgIdAdministrator', v)
      this.$store.commit('changeLoading', true)
      this.$axios.post('/user/modifyingAdministrator', this.$qs.stringify({ orgId: v })).then(res => {
        window.location.reload();
      })
    }
  },
  created () {
    if (this.userInfo.isPlatformManager === '1') {
      this.getOptions();
      this.role = window.localStorage.getItem('orgIdAdministrator')
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 200px;
  display: flex;
  align-items: center;
  float: right;
  height: 100%;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .app-breadcrumb.el-breadcrumb {
    line-height: 50px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.name {
  margin-top: 6px;
  margin-right: 10px;
  float: left;

  p.two {
    line-height: 18px;
  }
  p {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue